import React, { useState, useEffect } from 'react'
import Modal from 'react-responsive-modal'
import styles from './index.module.css'
import Button from '../../../components/Button'
import { Input, Select } from '../../../components/ModalInputs'
import { useDispatch, useSelector } from 'react-redux'
import { transferStudents, getGroupsList } from '../../../actions/groupsDoVd'
import moment from 'moment'

export default function TransferModal({
    isOpen,
    onClose,
    selectedStudents,
    currentGroupId,
    currentGroupName,
    type,
    params,
    onSuccess
}) {
    const dispatch = useDispatch();
    const { list } = useSelector(state => state.groups_do_vd);

    const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
    const [toGroupId, setToGroupId] = useState('');

    useEffect(() => {
        if (isOpen) {
            setDate(moment().format('YYYY-MM-DD'));
            setToGroupId('');
        }
    }, [isOpen]);

    // Фильтруем список групп - убираем текущую группу
    const availableGroups = list?.filter(g => g.xp_key !== currentGroupId) || [];

    const handleSave = async () => {
        if (!date || selectedStudents.length === 0) return;

        const data = {
            xp_date: date,
            mids: selectedStudents.map(s => s.mid),
            xp_group_from: currentGroupId,
            xp_group_to: toGroupId ? Number(toGroupId) : null
        };

        const result = await dispatch(transferStudents(data, type));
        if (result) {
            await dispatch(getGroupsList(type, params));
            onSuccess();
            onClose();
        }
    };

    const studentsText = selectedStudents.length === 1
        ? selectedStudents[0].fio
        : `Выбрано: ${selectedStudents.length} чел.`;

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            center
            closeOnOverlayClick={false}
        >
            <div className={styles.container}>
                <h3 className={styles.title}>Зачисление/Отчисление/Перевод</h3>

                <div className={styles.formGroup}>
                    <label className={styles.label}>Ученица</label>
                    <Input
                        value={studentsText}
                        disabled
                    />
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>Дата</label>
                    <Input
                        type='date'
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                    />
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>Откуда</label>
                    <Input
                        value={currentGroupName || ''}
                        disabled
                    />
                </div>

                <div className={styles.formGroup}>
                    <label className={styles.label}>Куда</label>
                    <Select
                        value={toGroupId}
                        onChange={(e) => setToGroupId(e.target.value)}
                    >
                        <option value=''>Отчисление (без перевода)</option>
                        {availableGroups.map(g => (
                            <option key={g.xp_key} value={g.xp_key}>{g.name}</option>
                        ))}
                    </Select>
                </div>

                <div className={styles.buttons}>
                    <Button onClick={handleSave}>
                        Сохранить
                    </Button>
                    <Button mode='white' onClick={onClose}>
                        Отмена
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
